import Vue from 'vue'
import ElementUI from 'element-ui'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import VueCookie from 'vue-cookie'
import '@/element-ui-theme/style.css'
import './styles/index.scss'
import './styles/element-variables.scss'
import '@/assets/scss/index.scss'
import * as ECharts from 'echarts'
import httpRequest from '@/utils/httpRequest'
// import { isAuth } from '@/utils'

Vue.use(VueCookie)
Vue.use(ElementUI)
Vue.config.productionTip = false

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$echarts = ECharts
// Vue.prototype.isAuth = isAuth     // 权限方法

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
